import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { PagingResponseModel } from '../../models/base/paging-response.model';
import { BaseService } from '../../templates/services/base-service.template';
import { ApiVisa } from '../../models/base/apivisa.model';
import { Pagination } from '../../models/pagination/pagination.model';
import { PGWTransactionContainerModel } from '../../models/pgw-transaction/pgw-transaction-container.model';
import { Core2Config } from '../../utils/core2-config';
import { getHttpHeader } from '../../utils/http-header.factory';
import { PGWTransactionEventModel } from '../../models/pgw-transaction/pgw-transnaction-event.model';
import { PGWTransactionRefundContainerModel } from '../../models/pgw-transaction/pgw-transaction-refund.model';

@Injectable({
  providedIn: 'root'
})
export class PGWTransactionAuditService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.UNIPIN_PREFIX + 'transaction-checker/';

  constructor(protected readonly http: HttpClient) {}

  public exportCsv(type: 'pgw' | 'doc', p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }export/csv/${ type }?${ p }`, null, { ...getHttpHeader(jwt_secret, tenantCode), responseType: 'text' });
  }

  public getDetail(type: 'pgw' | 'doc', guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<PGWTransactionContainerModel[]>>{
    return this.http.get<ApiResponseModel<PGWTransactionContainerModel[]>>(`${ api_domain_url }${ this.apiUrl }${ type }/${ guid }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getEventLog(txnGuid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<PGWTransactionEventModel>>{
    return this.http.get<PagingResponseModel<PGWTransactionEventModel>>(`${ api_domain_url }${ this.apiUrl }pgw/events/${ txnGuid }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getInquiryStatus(refNo: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ Core2Config.TENANT_DOMAIN_URL_PREFIX }pgw/provider-inquiry/${ tenantCode }`, { refNo }, getHttpHeader(jwt_secret, tenantCode));
  }

  public getList(type: 'pgw' | 'doc', p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<PGWTransactionContainerModel>>{
    return this.http.get<PagingResponseModel<PGWTransactionContainerModel>>(`${ api_domain_url }${ this.apiUrl }${ type }/query?${ p }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public resendPgwCallback(guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }resend-queue-pgw/${ guid }`, {}, getHttpHeader(jwt_secret, tenantCode));
  }

  public updateStatus(data: { bl_pgw_payment_txn_hdr_guid: string, response_txn_status: 'SUCCESS' | 'PROCESSING' | 'FAIL' | 'PENDING' | 'CANCELED_BY_PC' | 'CANCELED_BY_CUSTOMER' | 'CANCELED_BY_INTERNAL' | 'CANCELED_BY_TESTER' | 'EXPIRED' }, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }force-update-status`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public queryRefund(p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<PGWTransactionRefundContainerModel>>{
    return this.http.get<PagingResponseModel<PGWTransactionRefundContainerModel>>(`${ api_domain_url }${ this.apiUrl }refund/query?${ p }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getRefundDetail(guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<PGWTransactionRefundContainerModel>>{
    return this.http.get<PagingResponseModel<PGWTransactionRefundContainerModel>>(`${ api_domain_url }${ this.apiUrl }refund/${ guid }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public updateRefundStatus(guid: string, status: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa, remark?: string | null): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }update-refund-status`, { refund_guid: guid, response_txn_status: status, response_remark: remark }, getHttpHeader(jwt_secret, tenantCode));
  }

  public processInternalRefund(guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }process-internal-refund/${ guid }`, {}, getHttpHeader(jwt_secret, tenantCode));
  }
  
  public processNewInternalRefund(guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }process-maker-internal-refund/${ guid }`, {}, getHttpHeader(jwt_secret, tenantCode));
  }
}
